var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23668_174531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 0C292.8 0 324.8 20.7 340.9 51.1C373.8 41 411 49 437 75C463 101 471 138.3 460.9 171.1C491.3 187.2 512 219.2 512 256C512 292.8 491.3 324.8 460.9 340.9C471 373.8 463 411 437 437C411 463 373.7 471 340.9 460.9C324.8 491.3 292.8 512 256 512C219.2 512 187.2 491.3 171.1 460.9C138.2 471 101 463 75 437C49 411 41 373.7 51.1 340.9C20.7 324.8 0 292.8 0 256C0 219.2 20.7 187.2 51.1 171.1C41 138.2 49 101 75 75C101 49 138.3 41 171.1 51.1C187.2 20.7 219.2 0 256 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.938 191.138C362.338 200.438 362.338 215.638 352.938 225.038L241.038 337.038C231.738 346.438 216.538 346.438 207.138 337.038L151.138 281.038C141.738 271.738 141.838 256.538 151.138 247.138C160.438 237.738 175.638 237.738 185.038 247.138L224.038 286.138L319.038 191.138C328.338 181.738 343.538 181.838 352.938 191.138Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23668_174531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedWhite);
export default __webpack_public_path__ + "static/media/verified-white.4bce4e823aa923bc01f2d728ef1eaacf.svg";
export { ForwardRef as ReactComponent };